module.exports = __webpack_public_path__ + "static/img/空间or美陈-空间设计.fdf64f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/空间or美陈-空间设计.png
// module id = IHXW
// module chunks = 1